import MenuIcon from "../components/menu_icon";
import { connect } from 'react-redux';

function mapStateToProps(state) {
  return {
    unreadCount: state.unreadCount
  };
}

export default connect(mapStateToProps)(MenuIcon);
